import { render, staticRenderFns } from "./IconSvgArrowUp.vue?vue&type=template&id=bd09123c&scoped=true&"
import script from "./IconSvgArrowUp.vue?vue&type=script&lang=js&"
export * from "./IconSvgArrowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd09123c",
  null
  
)

export default component.exports